import Button from 'components/ReusableComponents/Button'
import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Dialog from 'components/ReusableComponents/Dialog'
import Table, {
  Cell,
  Row,
  TitleCell,
  TitleRow
} from 'components/ReusableComponents/Table'
import moment from 'moment'
import { formatPhoneNumber } from 'utils/helpers'

import styles from './ContactHistoryDialog.module.scss'

const ContactHistoryDialog = ({ contacts, handleClose }) => {
  return (
    <ConfirmationDialog
      title="Group contact history"
      theme="blacklist"
      maxWidth="900px"
      onClose={handleClose}
      onConfirm={handleClose}
    >
      <div className={styles.container}>
        <Table widths={[160, 180, 150, 110, 110, 140]}>
          <TitleRow className={styles.titleRow}>
            <TitleCell>Name</TitleCell>
            <TitleCell>E-mail</TitleCell>
            <TitleCell>Phone</TitleCell>
            <TitleCell>Added by</TitleCell>
            <TitleCell>Added on</TitleCell>
            <TitleCell></TitleCell>
          </TitleRow>
          {contacts.map(contact => (
            <Row className={styles.row} key={contact.email}>
              <Cell>
                {contact.firstName} {contact.lastName}
              </Cell>
              <Cell>{contact.email}</Cell>
              <Cell>{formatPhoneNumber(contact.phone)}</Cell>
              <Cell>{contact.addedUser}</Cell>
              <Cell>{moment(contact.addedOn).format('MMM DD, YYYY')}</Cell>
              <Cell>
                {contact.isActive ? (
                  <div className={styles.activeBadge}>Active</div>
                ) : (
                  <Button type="secondary" size="small">
                    Make Active
                  </Button>
                )}
              </Cell>
            </Row>
          ))}
        </Table>
      </div>
    </ConfirmationDialog>
  )
}

export default ContactHistoryDialog
